import { Injectable } from '@angular/core';
import { MoldsViewService } from '../../../../views/molds/services/view.service';
import { MoldRevisionItem } from '../../../../common/mold/models/item';
import { Observable } from 'rxjs';
import { HosesMoldFormDialogComponent } from '../dialog/form/form.component';

@Injectable()
export class HosesMoldViewService extends MoldsViewService<MoldRevisionItem> {
  override updateMoldDialog(
    molds: MoldRevisionItem['mold'][],
    item: MoldRevisionItem
  ): Observable<any> {
    return this.dialog
      .open(HosesMoldFormDialogComponent, {
        data: {
          molds,
          type: 'edit',
          selectItemCavities: true,
          moldRevision: item,
          department: this.departmentService.NAME,
        },
      })
      .afterClosed();
  }
}
